'use strict';

import $ from 'jquery';
import { lib } from '../../common/Library';
import Sortable from '../../../vendor/Sortable/Sortable.min.js';

require('../../../vendor/jquery.balloon.js/jquery.balloon.min.js');

$(function () {
    /**
     * 管理画面 スクリーニング削除
     */
    $(document).on('click', '#myscreening .delete', function () {

        let jsonId = $(this).data('index'),
            type = $(this).data('type'),
            title;

        //マイスクリーニング
        if (type === 0) {
            title = $(this).closest('.screening_detail').find('.title_row a').text();
        }
        //おすすめスクリーニング
        else if (type === 1) {
            title = $(this).closest('.screening_detail').find('.title_row a').data('title');
        }
        //過去のおすすめスクリーニング
        else if (type === 2) {
            title = $(this).closest('.screening_detail').find('.title_row a').data('title');
        }

        if (jsonId < 0) {
            return false;
        }

        $.confirm({
            title: '削除確認',
            content: '「' + title + '」を削除してよろしいですか？',
            closeIcon: true,
            type: 'orange',
            boxWidth: '500px',
            useBootstrap: false,
            backgroundDismiss: true,
            animation: 'top',
            buttons: {
                confirm: {
                    text: 'OK',
                    action: function() {

                        let postParam = {};

                        postParam.mode = 'del';
                        postParam.jsonId = jsonId;
                        postParam.type = type;

                        $.ajax({
                            url: $('#routeAjaxScreeningDelete').val(),
                            type: 'POST',
                            cache: false,
                            data: postParam,
                            dataType: 'text'
                        })
                        .done(function(ret) {
                            if (ret == 1) {
                                location.reload();
                            } else {
                                lib.jqAlert('処理エラー', '削除に失敗しました1');
                            }
                        })
                        .fail(function(jqXHR, textStatus, errorThrown) {
                            lib.jqAlert('処理エラー', '削除に失敗しました2');
                        });
                    }
                },
                cancel: {
                    text: 'キャンセル'
                }
            }
        });

        return false;
    });
});

/**
 * 管理画面 スクリーニング並び替え(view)
 * @returns {undefined}
 */
$(function() {
    if ($('.recommend_screening .detail_list').length > 0) {
        Sortable.create(
            $('.recommend_screening .detail_list')[0], {
                animation: 100
            }
        );
    }

    if ($('.archive_screening .detail_list').length > 0) {
        Sortable.create(
            $('.archive_screening .detail_list')[0], {
                animation: 100
            }
        );
    }
});

/**
 * 管理画面 スクリーニング並び替え JSONファイル更新
 */
$(function() {
    'use strict';

    $(document).on('click', '#myscreening.admin .move', function() {
        let type = $(this).data('type'),
            order = null,
            postParam = {},
            admin = true;

        $(this).siblings('.detail_list').find('.screening_detail').each(function() {
            if (order === null) {
                order = $(this).data('index');
            } else {
                order += '-' + $(this).data('index');
            }
        });

        if (order === null) {
            lib.jqAlert('処理エラー', '並び情報が取得できませんでした');
        }

        postParam.mode = 'move';
        postParam.order = order;
        postParam.admin = admin;
        postParam.type = type;

        $.ajax({
            url: $('#routeAjaxScreeningSort').val(),
            type: 'POST',
            cache: false,
            data: postParam,
            dataType: 'json'
        })
        .done(function(ret) {
            if (ret === 1) {
                location.reload();
            } else {
                lib.jqAlert('処理エラー', '並び替えに失敗しました');
            }
        })
        .fail(function() {
            lib.jqAlert('処理エラー', '並び替えに失敗しました');
        });
    });
});

$(function() {
    'use strict';

    /**
     * ギャラリーポップアップ balloon
     */
    $('#recommend_screening .description').each(function() {
        let html = $(this).closest('.screening_detail').find('.gallery_balloon').html();

        $(this).balloon({
            html: true,
            contents: html,
            showDuration: 0,
            hideDuration: 0,
            minLifetime: 0,
            position: 'bottom',
            tipSize: 14,
            classname: 'gallery_balloon'
        });
    });
});

/**
 * 過去のおすすめスクリーニングを閉じる
 */
$('.archive_close').on('click', function() {
    $('#recommend_screening #archive').slideUp('fast');
    $('.archive_close').hide();
    $('.archive_open').show();
});

/**
 * 過去のおすすめスクリーニングを開く
*/
$('.archive_open').on('click', function() {
    $('#recommend_screening #archive').slideDown('fast');
    $('.archive_open').hide();
    $('.archive_close').show();
});
